import { render, staticRenderFns } from "./SocialInteractionsPerPartner.vue?vue&type=template&id=bd9f6b0a"
import script from "./SocialInteractionsPerPartner.vue?vue&type=script&lang=ts"
export * from "./SocialInteractionsPerPartner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports